var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Main',[_c('ToolsPanel',{attrs:{"breadCrumbFirst":_vm.$t('home.title'),"breadCrumbFirstLink":'/',"title":_vm.$t('home.title')}},[_c('div',{staticClass:"form-create__buttons"})]),_c('ContentContainer',[_c('div',{staticClass:"home"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }